module.exports = __webpack_public_path__ + "static/media/scrap-tires-icon.c573460c.svg";